import { useState } from 'react';
import { useHistory } from 'react-router';

import { requireRole } from '@/helpers/permissions';
import EmployeeForm from '@/components/EmployeeForm';
import Page from '@/pages/Page';

export default requireRole('owner', NewEmployeePage);

function NewEmployeePage() {
  const history = useHistory();
  const [key, setKey] = useState(() => _.uniqueId('new-employee-form'));

  const resetForm = () => {
    history.push('/employees');
    _.delay(() => setKey(_.uniqueId('new-employee-form')));
  };

  return (
    <Page title="New Employee" backDefault="/employees">
      <EmployeeForm key={key} done={resetForm}/>
    </Page>
  );
}
